module.exports = ".message-panel {\n  position: fixed;\n  width: 30%;\n  bottom: 0px;\n  right: 0px;\n  z-index: -10;\n  margin-bottom: 0;\n  padding-bottom: 0; }\n\n.panel-footer {\n  display: block;\n  text-align: center;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/app-alerts/app-alerts.component.scss
// module id = 1107
// module chunks = 1